export const PaymentType = {
	BOOKING : "BOOKING",
    REBOOK : "REBOOK",
    CANCEL : "CANCEL"
}


// WEBPACK FOOTER //
// ./src/const/PaymentType.js